// third parties
import Cookies from 'js-cookie';

// project imports
import { ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY } from 'apis/apiConfig';

const cookies = {
	getAccessToken: () => {
		return Cookies.get(ACCESS_TOKEN_KEY);
	},
	setAccessToken: token => {
		Cookies.set(ACCESS_TOKEN_KEY, token, { domain: process.env.REACT_APP_DOMAIN });
	},
	clearAccessToken: () => {
		Cookies.remove(ACCESS_TOKEN_KEY, { domain: process.env.REACT_APP_DOMAIN });
	},
	getRefreshToken: () => {
		return Cookies.get(REFRESH_TOKEN_KEY);
	},
	setRefreshToken: token => {
		Cookies.set(REFRESH_TOKEN_KEY, token, { domain: process.env.REACT_APP_DOMAIN });
	},
	clearRefreshToken: () => {
		Cookies.remove(REFRESH_TOKEN_KEY, { domain: process.env.REACT_APP_DOMAIN });
	},
};

export default cookies;
